import { useTheme } from '@simplywallst/ui-core';
import NotificationOutline from '@simplywallst/ui-core/icons/NotificationOutline';
import Tooltip from '@components/Tooltip';

import { ToolTipText } from './styled';
import { generateReminderMessage } from '@components/NoteReminder/utils/reminderMessage';
import type { Reminders } from '@/components/Note';

type Props = {
  reminder: Reminders[number];
};

export const NoteReminderIcon = ({ reminder }: Props) => {
  const theme = useTheme();
  return reminder.status === 'pending' ? (
    <Tooltip
      title={<ToolTipText>{generateReminderMessage(reminder)}</ToolTipText>}
      light
      zIndex={99999}
    >
      <div>
        <NotificationOutline
          height={16}
          width={16}
          fill={theme.color.darkGray}
        />
      </div>
    </Tooltip>
  ) : null;
};
